<template>
  <member-invoke
    ref="members"
    :visible="show"
    :source-datas="newSourceDatas"
    :default-value="defaultValue"
    :is-must-last="true"
    @change="handleCascaderSub"
    @update="updateShow"
  />
</template>

<script>
import MemberInvoke from '@/components/mobile/Members'
import _ from 'lodash'
import eventBus from '@/lib/eventBus'

export default {
  components: {
    MemberInvoke
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    currentItem: {
      type: Object,
      default: () => ({})
    },
    sourceDatas: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      defaultValue: [],
      valueDesc: '',
      data: Object.assign({}, this.currentItem),
      newSourceDatas: this.sourceDatas,
      show: this.visible,
      divides: {
        1: this.$t('message["299"]'), // 分配到人
        2: this.$i18n.t('message["714"]'), // 平均分配
        3: this.$i18n.t('message["3"]'), // 按额度分配
        4: this.$i18n.t('message["1763"]') // 负责人指派
      }
    }
  },
  watch: {
    visible: {
      handler (val) {
        this.show = val
        if (val) {
          // this.data = Object.assign({}, this.currentItem)
          this.defaultValue = this.setDefaultValue()
        }
      },
      immediate: true
    }
  },
  async created () {
    this.init()
    eventBus.$on('clearCascader', this.clearCascader)
    eventBus.$on('updateFollowOptions', this.updateFollowOptions)
  },
  methods: {
    handleCascaderSub (result = {}) {
      this.data.valueDesc = result.text
      this.data.fieldvalue = result.value || []

      let res = _.reduce(result.value, (res, item) => {
        res[item.keyname] = item.id

        item.keyname === 'roleid' ? res.rolename = item.name : res.rolename = res.rolename || ''
        item.keyname === 'groupid' ? res.groupname = item.name : res.groupname = res.groupname || ''
        item.keyname === 'userid' ? res.truename = item.name : res.truename = res.truename || ''
        return res
      }, {})

      let keys = ['roleid', 'groupid', 'divide_type', 'userid']
      for (let name of keys) {
        if (!res[name]) {
          res[name] = 0
        }
      }
      console.log(res)
      this.data.info = Object.assign({}, this.currentItem.info, res)

      // if (this.data.fieldvalue.length) {
      this.$emit('change', {
        submit: true,
        fieldvalue: this.data.fieldvalue,
        info: this.data.info,
        valueDesc: this.data.valueDesc
      })
      // }

      this.hide()
    },
    updateShow (visible) {
      this.show = false
      eventBus.$emit('toggleFollowCascaderModal', visible)
    },

    hide () {
      this.show = false
      eventBus.$emit('toggleFollowCascaderModal', false)
    },

    init () {
      this.newSourceDatas = this.sourceDatas
    },
    setDefaultValue () {
      let arr = []
      /* const { info = {} } = this.data
      const { divides } = this
      const { roleid = 0, groupid = 0, userid = 0, divide_type: divideType, truename = '', rolename = '', groupname = '' } = info

      arr = []
      if (roleid) {
        arr.push({
          keyname: 'roleid',
          id: roleid,
          name: rolename
        })
      }
      if (groupid) {
        arr.push({
          keyname: 'groupid',
          id: groupid,
          name: groupname
        })
      }

      if (divideType === 1 && userid) {
        arr.push({
          keyname: 'divide_type',
          id: divideType,
          name: divides[divideType]
        })
        arr.push({
          keyname: 'userid',
          id: userid,
          name: truename
        })
      } else if (userid && !divideType) {
        arr.push({
          keyname: 'userid',
          id: userid,
          name: truename
        })
      } else if (divideType) {
        arr.push({
          keyname: 'divide_type',
          id: divideType,
          name: divides[divideType]
        })
      }

      this.data.fieldvalue = arr */
      arr = this.setValue([], this.newSourceDatas)
      return arr
    },
    setValue (res = [], data = []) {
      data.forEach(item => {
        const { keyname, id, name, children = [] } = item || {}
        const { info = {} } = this.data || {}
        if (id === info[keyname]) {
          res.push({
            keyname,
            id,
            name,
            children
          })
          if (children.length) {
            this.setValue(res, children)
          }
        }
      })
      return res
    },

    /* setValueDesc (res, children) {
      for (let item of this.defaultValue) {
        for (let one of children) {
          if (item.keyname === one.keyname && parseInt(item.id) === parseInt(one.id)) {
            // this.$set(item, 'name', one.name)
            res.push(one.name || one.truename)
            if (one.children && one.children.length) {
              this.setValueDesc(res, one.children)
            }
          }
        }
      }
      return res.join('/')
    }, */
    clearCascader () {
      this.defaultValue = []
      this.data.fieldvalue = []
      this.data.info = {}
      this.data.valueDesc = ''

      this.$emit('change', {
        fieldvalue: this.data.fieldvalue,
        info: this.data.info,
        valueDesc: this.data.valueDesc
      })
    },
    updateFollowOptions (data) {
      this.newSourceDatas = data
      this.data.valueDesc = ''
    }
  }
}
</script>

<style>
</style>
